module.exports = __webpack_public_path__ + "static/media/insert_room_tag.eff0e147.png";